export default "__VITE_ASSET__fff6c734__"